import { render, staticRenderFns } from "./CostsModal.vue?vue&type=template&id=2cb1dffc&scoped=true&lang=html&"
import script from "./CostsModal.vue?vue&type=script&lang=js&"
export * from "./CostsModal.vue?vue&type=script&lang=js&"
import style0 from "./CostsModal.vue?vue&type=style&index=0&id=2cb1dffc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb1dffc",
  null
  
)

export default component.exports